import { BaseAttribute } from '../../../data/types/attributes';
import { EN_AR_TRANSLATION_SPLIT_CHAR } from '../constants';

export const getAttributesNames = (attributes: BaseAttribute[]) => {
  const options = attributes
    .filter((attr) => attr.is_variable)
    .map((item) => {
      return {
        label:
          item.name_en +
          `${item.name_ar !== undefined ? `-${item.name_ar}` : ``}`,
        value: item.name_en,
      };
    });
  return options;
};

export const getOptionDropDownFormat = (
  obj: any,
  official_values_ar: string[],
) => {
  const options = obj.map((item: string, index: number) => {
    return {
      label:
        item +
        `${
          official_values_ar[index] !== undefined
            ? `${EN_AR_TRANSLATION_SPLIT_CHAR}${official_values_ar[index]}`
            : ``
        }`,
      value: item,
    };
  });
  return options || [];
};
